import { createContext } from 'react'
import { mineralInitialState } from './mineralInitialState'

const MineralContext = createContext(mineralInitialState)

export default MineralContext
